import { Button, Grid, Tooltip } from "@material-ui/core";
import React from "react";
import "./Apm.less";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import TodayIcon from "@material-ui/icons/Today";
import EventCalendar from "../../../EventCalender";
import moment from "moment";
import DialogModal from "../../../common/DialogModal/Dialog";

const monthArray=new Array(12);
monthArray[0]="January";
monthArray[1]="February";
monthArray[2]="March";
monthArray[3]="April";
monthArray[4]="May";
monthArray[5]="June";
monthArray[6]="July";
monthArray[7]="August";
monthArray[8]="September";
monthArray[9]="October";
monthArray[10]="November";
monthArray[11]="December";

const events = [
    {
        start: "2022-2-2",
        end: "2022-2-2",
        eventClasses: "optionalEvent",
        title: "test event",
        description: "This is a test description of an event",
    },
    {
        start: "2022-3-2",
        end: "2022-3-3",
        title: "test event",
        description: "This is a test description of an event",
        data: "you can add what ever random data you may want to use later",
    },
];
class Apm extends React.Component {
  constructor(props) {
    super(props);
    const currentMonth = Number(moment().format("M")) - 1; // Jan month start from 0
    const currentYear = Number(moment().format("YYYY"))
    this.state = {
      month: currentMonth,
      year: currentYear,
      nextMonth: currentMonth == 12 ? 1 : currentMonth + 1,
      nextYear: currentMonth == 12 ? currentYear + 1 : currentYear,
      showWorkOrderDetails: false
    };
  }

  componentDidMount() {
    
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.propertyId != this.props.propertyId ||
      newProps.startDate != this.props.startDate ||
      newProps.endDate != this.props.endDate
    ) {
      //call api
    }
  }

  /** Handle APM action */
  handleAction = (action) => {
    const {month,year} = this.state;
    let updatedMonth = Number(month);
    let updatedYear = Number(year);

    if(action == "Today")
    {
      updatedMonth = Number(moment().format("M")) - 1; // Jan month start from 0
      updatedYear = Number(moment().format("YYYY"));
    }
    else if(action == "Next")
    {
      updatedMonth = updatedMonth == 12 ? 1 : updatedMonth + 1;
      updatedYear = updatedMonth == 12 ? updatedYear + 1 : updatedYear;
    }
    else
    {
      updatedMonth = updatedMonth == 1 ? 12 : updatedMonth - 1;
      updatedYear = updatedMonth == 1 ? updatedYear - 1 : updatedYear;
    }

    this.setState(
    {
      month:updatedMonth, 
      year: updatedYear,
      nextMonth: (updatedMonth == 12) ? 1 : updatedMonth + 1 ,
      nextYear: (updatedMonth == 12) ? updatedYear + 1 : updatedYear
    });
  }

  /** Show work order */
  showWorkOrder = (showDetails=false) => {
    this.setState({showWorkOrderDetails:showDetails});
  }

  /** call on handle close */
  handleClose = () => {
    this.setState({showWorkOrderDetails:false});
  }

  render() {
    const {month, year, nextMonth, nextYear, showWorkOrderDetails} = this.state;
    return (
      <>
        <Grid className={"pb-10"}>
            <Tooltip title={"Previous"}>
                <Button
                  variant={"contained"}
                  size={"small"}
                  style={{ marginRight: "0.5rem" }}
                  onClick={() => this.handleAction("Previous")}
                  aria-label={"Previous"}
                  startIcon={
                    <ArrowBackIosIcon
                      fontSize={"inherit"}
                      style={{ color: "var(--common--Text--color)" }}
                    />
                  }
                >
                  {"Previous\r"}
                </Button>
            </Tooltip>
            <Tooltip title={"Next"}>
                <Button
                  variant={"contained"}
                  size={"small"}
                  style={{ marginRight: "0.5rem" }}
                  onClick={() => this.handleAction("Next")}
                  aria-label={"Next"}
                  startIcon={
                    <ArrowForwardIosIcon
                      fontSize={"inherit"}
                      style={{ color: "var(--common--Text--color)" }}
                    />
                  }
                >
                  {"Next\r"}
                </Button>
            </Tooltip>
            <Tooltip title={"Next"}>
                <Button
                  variant={"contained"}
                  size={"small"}
                  onClick={() => this.handleAction("Today")}
                  aria-label={"Next"}
                  startIcon={
                    <TodayIcon
                      fontSize={"inherit"}
                      style={{ color: "var(--common--Text--color)" }}
                    />
                  }
                >
                  {"Today\r"}
                </Button>
            </Tooltip>
        </Grid>
        <Grid container>
          <Grid item xs={6} className={"pr-3 month-label"}>
            {
              monthArray[month] + ", " + year
            }
          </Grid>
          <Grid item xs={6} className={"month-label"}>
            {
              monthArray[nextMonth] + ", " + nextYear
            }
          </Grid>
        </Grid>
        <Grid container>
        <Grid item xs={6} className={"pr-3"}>
          <EventCalendar
            month={month}
            year={year}
            wrapTitle
            events={events}
            onEventClick={(target, eventData) => 
                this.showWorkOrder(true, eventData)}
          />
        </Grid>  
        <Grid item xs={6} className={"pl-3"}>
          <EventCalendar
            month={nextMonth}
            year={nextYear}
            wrapTitle
            events={events}
            onEventClick={(target, eventData, day) => 
              {
                console.log(target,eventData, day)
              }}
          />{";\r"}
        </Grid>
        </Grid>
        <DialogModal
          title={"WorkOrder Details"}
          open={showWorkOrderDetails || false}
          onClose={this.handleClose}
          fullWidth
          maxWidth={"md"}
          className={"apm"}
        >
          <div>
            {"Modal Content"}
          </div>
        </DialogModal>
      </>
    );
  }
}
export default Apm;
